import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faBook, faPaintBrush, faPlay } from "@fortawesome/free-solid-svg-icons";
import { createContext, CSSProperties, Dispatch, ReactNode, Ref, RefObject, SetStateAction, useContext, useEffect, useRef, useState } from "react";

const SiteContext = createContext<{
    nameDrawn:{get:boolean,set?:Dispatch<SetStateAction<boolean>>},
    menuItemsDrawn:{get:number,set?:Dispatch<SetStateAction<number>>},
    pageRef?:RefObject<HTMLDivElement | null>,
    provenceElementRef?:RefObject<HTMLVideoElement | null>,
    isMobile?:boolean,
}>({
    nameDrawn:{get:false},
    menuItemsDrawn:{get:0},
    isMobile:false,
});

export const useSite = () => useContext(SiteContext);

export const SiteContextProvider = (props:any) => {

    const [nameDrawn, setNameDrawn] = useState(false);
    const [menuItemsDrawn, setMenuItemsDrawn] = useState(0);
    const [galleryIndex, setGalleryIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    const pageRef = useRef<HTMLElement>(null);
    const provenceElementRef = useRef<HTMLVideoElement>(null);

    useEffect(()=>{
        const checkValue = window.navigator.userAgent.toLowerCase();
        checkValue.includes('iphone') && setIsMobile(true);
        checkValue.includes('android') && setIsMobile(true);
    },[]);

    return(
        <SiteContext.Provider {...props} value={{
            nameDrawn:{get:nameDrawn,set:setNameDrawn},
            menuItemsDrawn:{get:menuItemsDrawn,set:setMenuItemsDrawn},
            galleryIndex:{get:galleryIndex,set:setGalleryIndex},
            isMobile:isMobile,
            pageRef:pageRef,
            provenceElementRef:provenceElementRef,
        }}></SiteContext.Provider>
    );

};

export const SiteSyles = {
    siteYellow:"#ff0",
    siteBlue:"#00f",
    row:{
        display:'flex',
    } as CSSProperties,
    column:{
        display:'flex',
        flexDirection:'column',
    } as CSSProperties,
    flexOne:{
        display:'flex',
        flex:1,
    } as CSSProperties,
    center:{
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
    } as CSSProperties,
    centerStart:{
        display:'flex',
        alignItems:'center',
        justifyContent:'flex-start',
    } as CSSProperties,
    centerEnd:{
        display:'flex',
        alignItems:'center',
        justifyContent:'flex-end',
    } as CSSProperties,
    text:{
        fontFamily:'Science Gothic',
    } as CSSProperties,
    box: {
        display:'flex',
        borderStyle:'solid',
        borderWidth:1,
        borderColor:"#cc0",
        borderRadius:5,
        overflow:'hidden',
        boxSizing:'border-box',
        boxShadow:'0px 0px 4px #ff0',
    } as CSSProperties,
};

export const useIsVisible = (ref:RefObject<HTMLElement | null>) => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    // Create an IntersectionObserver to observe the ref's visibility
    const observer = new IntersectionObserver(([entry]) => 
      setIntersecting(entry.isIntersecting)
    );

    // Start observing the element
    ref.current && observer.observe(ref.current);

    // Cleanup the observer when the component unmounts or ref changes
    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return isIntersecting;
}

export const useIsFullscreen = (ref:RefObject<HTMLElement | null>) => {
    const [isFullscreen, setIsFullscreen] = useState(false);

    const handleChange = () => {
        setIsFullscreen(document.fullscreenElement === ref.current);
    };

    useEffect(()=>{
        ref.current?.addEventListener('fullscreenchange',handleChange);
        return(()=>{
            ref.current?.removeEventListener('fullscreenchange',handleChange);
        });
    },[ref]);

    return isFullscreen;
};